import * as Yup from 'yup';
import moment from 'moment';
import {
  isRelativeDateBound, isValidRelativeDateBound, resolveDateValidationBound, 
} from './dateValidation';

export const isDateField = (type) => ['date', 'datetime'].includes(type);
export const hasValidationBounds = (type) => ['string', 'number', 'date', 'datetime'].includes(type);
export const getBoundInputType = (type) => isDateField(type)
  ? (type === 'datetime' ? 'datetime-local' : 'date') : 'number';
export const getBoundLabelKey = (type, bound) => `${bound}_${isDateField(type) ? type : type === 'string' ? 'chars' : 'value'}`;

export const formatValidationBound = (type, value) => {
  if (value === '' || value == null) return '';
  if (!isDateField(type)) return value;
  const date = moment(value, moment.ISO_8601, true);
  return date.isValid() ? date.format(type === 'datetime' ? 'YYYY-MM-DDTHH:mm:ss' : 'YYYY-MM-DD') : value;
};

// Changing the data type also changes what a bound means (length, number or date).
export const resetTypeValidation = (validate = {}) => {
  const result = {
    ...validate, 
  };
  delete result.min;
  delete result.max;
  delete result.regex;
  return result;
};

export const getTemplateValidationSchema = (type, format, messages = {}) => {
  const bound = () => {
    if (isDateField(type)) {
      return Yup.mixed().nullable().transform((value, original) => original === '' || original == null ? null
        : original instanceof Date ? moment(original).format(type === 'datetime' ? 'YYYY-MM-DDTHH:mm:ss' : 'YYYY-MM-DD') : value)
        .test('valid-date', messages.date || 'Ingresa una fecha válida.', (value) => value == null
          || (isRelativeDateBound(value) ? isValidRelativeDateBound(value) && resolveDateValidationBound(value, type, 'min') !== null
            : typeof value === 'string'
              && (type === 'datetime' ? /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(value) : /^\d{4}-\d{2}-\d{2}$/.test(value))
              && moment(value, moment.ISO_8601, true).isValid()));
    }
    let schema = Yup.number().nullable().transform((value, original) => original === '' || original == null ? null : value)
      .typeError(messages.number || 'Ingresa un número válido.');
    if (type === 'string' || format === 'integer') {
      schema = schema.integer(messages.integer || 'Ingresa un número entero.');
    }
    if (type === 'string') schema = schema.min(0, messages.length || 'La longitud no puede ser negativa.');
    return schema;
  };
  return Yup.object().shape({
    min: hasValidationBounds(type) ? bound() : Yup.mixed().strip(),
    max: hasValidationBounds(type) ? bound().test('bound-order', messages.order || 'El máximo debe ser mayor o igual que el mínimo.', function (value) {
      const { min } = this.parent;
      if (value == null || min == null) return true;
      if (!isDateField(type)) return value >= min;
      const now = new Date();
      const lower = resolveDateValidationBound(min, type, 'min', now);
      const upper = resolveDateValidationBound(value, type, 'max', now);
      return !lower || !upper || upper >= lower;
    }) : Yup.mixed().strip(),
    required: Yup.boolean().default(false),
    requiredAnyOf: Yup.array().of(Yup.string().trim()).min(1).optional(),
    regex: type === 'string' ? Yup.string().nullable().default('').test('valid-regex', messages.regex || 'Ingresa una expresión regular válida.', (value) => {
      try {
        if (value) new RegExp(value);
        return true;
      } catch (_error) {
        return false;
      }
    }) : Yup.mixed().strip(),
  });
};
